import { Add } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import * as React from 'react';
import { UseFormReturn, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import { EmployeeItemInfoData } from '~/components/GenericList/EmployeeItemInfo';
import { OrgUnitAltManagerRow } from '~/scenes/PortalViews/Views/PortalAltMgr/components/OrgUnitPopup/components/OrgUnitAltManagersFormSection/OrgUnitAltManagerRow';
import { OrgUnitSectionWrapper } from '~/scenes/PortalViews/Views/PortalAltMgr/components/OrgUnitPopup/components/OrgUnitSectionWrapper';
import { OrgUnitFormData } from '~/scenes/PortalViews/Views/PortalAltMgr/components/OrgUnitPopup/types';

type PropsType = {
  form: UseFormReturn<OrgUnitFormData>;
  alternateMgrs: EmployeeItemInfoData[];
  disabled?: boolean;
  commonTextFieldProps?: Partial<TextFieldProps>;
};

export const OrgUnitAltManagersFormSection = (props: PropsType) => {
  const { form, disabled } = props;
  const { control } = form;

  const { t } = useTranslation();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'alternateManagers',
  });

  const handleAddRow = () => {
    append({
      id: uuidv4(),
      manager: null,
      startDate: null,
      endDate: null,
      savedWithoutDates: false,
    });
  };

  if (fields.length <= 0 && disabled) {
    return <></>;
  }

  return (
    <Grid item xs={12}>
      <OrgUnitSectionWrapper>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={12}>
            <label style={{ fontWeight: 'bold' }}>{t('laAltManagers')}</label>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                handleAddRow();
              }}
              sx={{ marginLeft: '16px' }}
              size={'small'}
              startIcon={<Add />}
              disabled={disabled}
            >
              {t('laAdd')}
            </Button>
          </Grid>

          {fields.length > 0 && (
            <Grid item xs={12}>
              <Grid container direction={'column'} spacing={2}>
                {fields.map((item, index) => {
                  return (
                    <OrgUnitAltManagerRow
                      key={`alt-manager-${item.id}`}
                      {...props}
                      item={item}
                      index={index}
                      remove={remove}
                    />
                  );
                })}
              </Grid>
            </Grid>
          )}
        </Grid>
      </OrgUnitSectionWrapper>
    </Grid>
  );
};
